/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Deletetitle2Inputs */

const zh_organizationsettings_deletetitle2 = /** @type {(inputs: Organizationsettings_Deletetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定删除组织？`)
};

const en_organizationsettings_deletetitle2 = /** @type {(inputs: Organizationsettings_Deletetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete organization?`)
};

const es_organizationsettings_deletetitle2 = /** @type {(inputs: Organizationsettings_Deletetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar organización?`)
};

/**
* | output |
* | --- |
* | "Delete organization?" |
*
* @param {Organizationsettings_Deletetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_deletetitle2 = /** @type {((inputs?: Organizationsettings_Deletetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Deletetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_deletetitle2(inputs)
	if (locale === "en") return en_organizationsettings_deletetitle2(inputs)
	return es_organizationsettings_deletetitle2(inputs)
});
export { organizationsettings_deletetitle2 as "organizationSettings_deleteTitle" }